import {localizeImage} from '../../i18n/images';
import {useTranslation} from '../../i18n/translation';
import React from 'react';
import {Link} from 'react-router-dom';
import Navigation from '../utils/Navigation';
import SeoHelmet from '../utils/seo';
import {useTheme} from '../header/Header';
import {ProductFaq} from '../utils/ProductFaq';
import '../../css/lizing/leasing-refresh.css';
import '../../css/lizing/rosagro.css';

const FAQ_ITEMS = [
    {
        question: 'Кто может подать заявку на лизинг через Росагролизинг?',
        answer: 'Юридические лица и ИП, работающие в сфере АПК не менее года, без просроченной задолженности по налогам, сборам и кредитам.'
    },
    {
        question: 'Какой минимальный первоначальный взнос?',
        answer: 'От 0% — размер первого взноса не зависит от предмета лизинга.'
    },
    {
        question: 'На какой срок можно оформить лизинг?',
        answer: 'До 7 лет. Доступны как аннуитетные (равные), так и гибкие графики платежей.'
    },
    {
        question: 'Нужен ли залог или поручительство?',
        answer: 'Нет. Гарантийное обеспечение и дополнительный залог не требуются — обеспечением выступает сам предмет лизинга.'
    },
    {
        question: 'Сколько рассматривается заявка?',
        answer: 'Решение по льготной программе принимается за 1 рабочий день.'
    },
    {
        question: 'Можно ли оформить сделку дистанционно?',
        answer: 'Да. Электронная подпись позволяет провести сделку онлайн без визита в офис, почтовых расходов и риска потери документов.'
    },
    {
        question: 'Какая минимальная сумма сделки?',
        answer: 'От 400 000 ₽. Сделки заключаются по всей России.'
    }
];

const SESPEL_FINANCE_LEASING = [
    {
        url: '/lizing/lizing_finance',
        title: 'Лизинг от «Сеспель-Финанс»',
        image: 'lizing/lizingSespelFinance.webp'
    }
];

const getImage = (path) => {
    if (!path) return "";
    const clean = path.replace(/^\.?\//, "");
    return `/images/${clean}`;
};

export default function LizingRosagro() {
    const {english, t} = useTranslation();
    const {theme} = useTheme();

    return <>
        <Navigation/>
        <SeoHelmet
            title={t("Лизинг от АО «Росагролизинг» — Сеспель")}
            description={t("Программы лизинга техники Сеспель от АО «Росагролизинг»: от 0% первый взнос, срок до 7 лет, решение за 1 день. Требования, порядок оформления и ответы на частые вопросы.")}
            canonicalUrl={english ? "/en/lizing/lizing_rosagro" : "/lizing/lizing_rosagro"}
        />
        <div className="overlay">
            <div className={`complexBack ${theme}`}/>
            <main className={`leasing-page rosagro-page ${theme}`}>

                {/* Hero */}
                <section className="leasing-hero rosagro-hero">
                    <div className="leasing-hero-copy">
                        <span className="leasing-eyebrow">{t("Техника Сеспель · Финансирование")}</span>
                        <h1>{t("Лизинг от АО «Росагролизинг»")}</h1>
                        <p>{t("Федеральная программа обновления техники для агропромышленного комплекса: от 0% первый взнос, срок до 7 лет, решение за 1 день.")}</p>
                        <div className="leasing-actions">
                            <a className="leasing-button" href="#rosagro-programs">{t("Условия программ")}<span aria-hidden="true">↗</span>
                            </a>
                            <a className="leasing-contact" href="tel:+79034764230">{t("Консультация специалиста ↗")}</a>
                        </div>
                        <ul className="rosagro-hero-facts">
                            <li><strong>{t("от 0%")}</strong><span>{t("первый взнос")}</span></li>
                            <li><strong>{t("до 7 лет")}</strong><span>{t("срок лизинга")}</span></li>
                            <li><strong>{t("1 день")}</strong><span>{t("решение по заявке")}</span></li>
                        </ul>
                    </div>
                    <div className="rosagro-hero-panel">
                        <span className="leasing-eyebrow">{t("АО «Росагролизинг»")}</span>
                        <strong>{t("от 0%")}</strong>
                        <p>{t("первоначальный взнос")}</p>
                        <span>{t("Для предприятий агропромышленного комплекса")}</span>
                    </div>
                </section>

                {/* Programs */}
                <section id="rosagro-programs" className="rosagro-section">
                    <div className="leasing-section-heading">
                        <span className="leasing-eyebrow">{t("01 / Программы")}</span>
                        <h2>{t("Условия финансирования")}</h2>
                        <p>{t("Две программы Росагролизинга под разные задачи предприятия.")}</p>
                    </div>

                    <div className="rosagro-grid">
                        <article className="rosagro-card rosagro-card--accent">
                            <header>
                                <h3>{t("Федеральный лизинг")}</h3>
                                <span className="rosagro-tag">{t("Для любых АПК-предприятий")}</span>
                            </header>
                            <dl>
                                <div><dt>{t("Удорожание")}</dt><dd>{t("от 7%")}</dd></div>
                                <div><dt>{t("Срок")}</dt><dd>{t("до 7 лет")}</dd></div>
                                <div><dt>{t("Первый взнос")}</dt><dd>{t("от 0%")}</dd></div>
                            </dl>
                            <p>{t("Первый взнос не зависит от предмета лизинга. Подходит для обновления и расширения автопарка.")}</p>
                        </article>

                        <article className="rosagro-card rosagro-card--accent">
                            <header>
                                <h3>{t("Льготный лизинг")}</h3>
                                <span className="rosagro-tag">{t("Ускоренное рассмотрение")}</span>
                            </header>
                            <dl>
                                <div><dt>{t("Первый взнос")}</dt><dd>{t("от 0%")}</dd></div>
                                <div><dt>{t("Срок")}</dt><dd>{t("до 7 лет")}</dd></div>
                                <div><dt>{t("Рассмотрение заявки")}</dt><dd>{t("1 день")}</dd></div>
                            </dl>
                            <p>{t("Гибкий график платежей и быстрое принятие решения. Идеально для сезонных задач.")}</p>
                        </article>
                    </div>

                    <ul className="rosagro-summary-list">
                        <li>{t("Сделки от")} <strong>400 000 ₽</strong> {t("по всей России")}</li>
                        <li>{t("Аннуитетные или гибкие платежи")}</li>
                        <li>{t("Гарантийное обеспечение и залог не требуются")}</li>
                    </ul>
                </section>

                {/* Participants */}
                <section className="rosagro-section rosagro-card">
                    <span className="leasing-eyebrow">{t("02 / Участники")}</span>
                    <h2>{t("Кому подходит программа")}</h2>
                    <ul className="rosagro-checklist">
                        <li>{t("Юридическим лицам и ИП, производящим сельхозпродукцию, а также организациям её производства, переработки, сбыта и сельскохозяйственных услуг.")}</li>
                        <li>{t("Срок работы компании — больше года.")}</li>
                        <li>{t("Нет просроченных налогов, сборов, взносов, обязательных платежей и кредитов.")}</li>
                    </ul>
                </section>

                {/* Steps */}
                <section className="rosagro-section">
                    <span className="leasing-eyebrow">{t("03 / Оформление")}</span>
                    <h2>{t("Три шага к заявке")}</h2>

                    <ol className="rosagro-steps">
                        <li>
                            <span className="rosagro-step-num">01</span>
                            <h3>{t("Заполните анкету")}</h3>
                            <p>{t("Расскажите о компании и предмете лизинга.")}</p>
                        </li>
                        <li>
                            <span className="rosagro-step-num">02</span>
                            <h3>{t("Соберите документы")}</h3>
                            <p>{t("Стандартный пакет для юрлиц и ИП.")}</p>
                        </li>
                        <li>
                            <span className="rosagro-step-num">03</span>
                            <h3>{t("Передайте в Росагролизинг")}</h3>
                            <p>{t("Через личный кабинет или электронную подпись.")}</p>
                        </li>
                    </ol>

                    <div className="rosagro-card rosagro-card--cta">
                        <div>
                            <h3>{t("Подайте документы дистанционно")}</h3>
                            <p>{t("Электронная подпись позволяет оформить сделку онлайн без поездки в офис, почтовых расходов и риска потери документов.")}</p>
                            <p className="rosagro-muted">{t("Почтовый адрес: 127137, Москва, а/я 26.")}</p>
                        </div>
                        <a className="leasing-button" href="https://www.rosagroleasing.ru/" target="_blank" rel="noopener noreferrer">{t("На сайт Росагролизинга")}<span aria-hidden="true">↗</span>
                        </a>
                    </div>
                </section>

                {/* FAQ — общий компонент */}
                <ProductFaq items={FAQ_ITEMS.map(item => ({question: t(item.question), answer: t(item.answer)}))} theme={theme}
                            introduction={t("Ответы на вопросы об условиях и оформлении лизинга.")}/>

                {/* Contact */}
                <section className="rosagro-section rosagro-card rosagro-contact">
                    <div>
                        <h2>{t("Поможем с выбором техники")}</h2>
                        <p>{t("Специалист ответит на вопросы о технике Сеспель, комплектации и оформлении лизинга.")}</p>
                    </div>
                    <div>
                        <a className="leasing-phone" href="tel:+79034764230">+7 (903) 476-42-30</a>
                    </div>
                </section>

                <LeasingEquipment
                    items={SESPEL_FINANCE_LEASING}
                    theme={theme}
                    id="sespel-finance-program"
                    eyebrow={t("Лизинг от производителя")}
                    title={t("Лизинг от «Сеспель-Финанс»")}
                    description={t("Дочерняя лизинговая компания завода «Сеспель»: 5% первый взнос, техника по заводским ценам, решение за 1 день.")}
                />

                <Link className="rosagro-back" to={english ? "/en/lizing" : "/lizing"}>{t("← Все программы лизинга")}</Link>
            </main>
        </div>
    </>;
}

export function LeasingEquipment({
                                             items,
                                             theme,
                                             id = 'leasing-equipment',
                                             eyebrow = 'Оборудование завода',
                                             title = 'Техника, доступная в лизинг',
                                             description = 'Любую позицию каталога «Сеспель» можно взять по программам лизинга.'
                                         }) {
    const {english, t} = useTranslation();
    if (!items?.length) return null;

    return (
        <section className={`related-equipment ${theme}`} aria-labelledby={`${id}-title`}>
            <div className="related-equipment__heading">
                <div>
                    <span className="related-equipment__eyebrow">{t(eyebrow)}</span>
                    <h2 id={`${id}-title`}>{t(title)}</h2>
                    {description && <p>{t(description)}</p>}
                </div>
            </div>

            <div className="related-equipment__grid">
                {items.map(item => (
                    <Link className="related-equipment__card" to={english ? `/en${item.url}` : item.url} key={item.url}>
                        <div className="related-equipment__photo">
                            {item.image && (
                                <img loading="lazy" src={getImage(localizeImage(item.image, english))} alt={t(item.title)}/>
                            )}
                        </div>
                        <div className="related-equipment__content">
                            <h3>{t(item.title)}</h3>
                            <span>{t("Подробнее")}<span aria-hidden="true">→</span></span>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
}